import { CLEAR_TOAST, SHOW_TOAST } from "./constant";

const initialState = {
  message: null,
  type: null,
  isAnimate:false
};

export const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        message: action.payload.message,
        type: action.payload.type,
        isAnimate: action.payload.isAnimate
      };

    case CLEAR_TOAST:
      return initialState;

    default:
      return state;
  }
};